
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicules-tourisme/19-voiture-prestige",
      function () {
        return require("private-next-pages/vehicules-tourisme/19-voiture-prestige/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicules-tourisme/19-voiture-prestige"])
      });
    }
  